import styled from 'styled-components';

export const MobileProfileLastDepositStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--color-neutral-20);
    padding: 16px;
    width: 100%;
    border-radius: 16px;
    margin-top: 16px;
`;

export const MobileProfileLastDepositTitleStyled = styled.h4`
    font-weight: 600;
    font-size: 16px;
    color: var(--color-white-60);
`;

export const MobileProfileLastDepositRepeatButtonStyled = styled.button`
    display: flex;
    padding: 8px 12px;
    svg {
        fill: var(--color-white-95);
    }
`;

export const MobileProfileLastDepositProviderInfoStyled = styled.div`
    display: flex;
    align-items: center;
    margin-top: 12px;
    
    > div {
        font-size: 24px;
    }
    
    span {
        color: var(--color-white-95);
        font-weight: 600;
        font-size: 16px;
        margin-left: 12px;
    }
`;
